import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton, TextField, Button, Box } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Controller, useForm } from 'react-hook-form';
import { useChangePartnerMutation } from 'widgets/partner/api/getPartnerApi';

type DrawerChangePartnerPropsType = {
  title_kk: string;
  title_ru: string;
  title_kg: string;
  title_uz: string;
  title_en: string;
  description_kk: string;
  description_ru: string;
  description_kg: string;
  description_uz: string;
  description_en: string;
  photo_preview: string;
  partnerId: number;
};

type FormDataType = {
  title_kk: string;
  title_ru: string;
  title_kg: string;
  title_uz: string;
  title_en: string;
  description_kk: string;
  description_ru: string;
  description_kg: string;
  description_uz: string;
  description_en: string;
  photo_preview: string;
};

export const DrawerChangePartner = ({
  title_kk,
  title_ru,
  title_kg,
  title_uz,
  title_en,
  description_kk,
  description_ru,
  description_kg,
  description_uz,
  description_en,
  partnerId,
}: DrawerChangePartnerPropsType) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const {
    control,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      title_kk,
      title_ru,
      title_kg,
      title_uz,
      title_en,
      description_kk,
      description_ru,
      description_kg,
      description_uz,
      description_en,
    },
  });

  const [changePartnerRequest] = useChangePartnerMutation();

  const singIn = () => {
    changePartnerRequest({
      partner_id: partnerId,
      title_kk: control._fields.title_kk?._f.value,
      title_ru: control._fields.title_ru?._f.value,
      title_kg: control._fields.title_kg?._f.value,
      title_uz: control._fields.title_uz?._f.value,
      title_en: control._fields.title_en?._f.value,
      description_kk: control._fields.description_kk?._f.value,
      description_ru: control._fields.description_ru?._f.value,
      description_kg: control._fields.description_kg?._f.value,
      description_uz: control._fields.description_uz?._f.value,
      description_en: control._fields.description_en?._f.value,
      photo_preview: 'TO DO',
    }).then(() => {
      dispatch(setDrawerOpen(false));
    });
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Новый партнер
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div style={{ marginBottom: '20px' }}>Информация о партнере</div>
            <Controller
              name="title_kk"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на казахском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_kk && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="title_ru"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на русском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_ru && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="title_kg"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на киргизском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_kg && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="title_uz"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на узбекском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_uz && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="title_en"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование на английском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title_en && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="description_kk"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Описание на казахском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.description_kk && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="description_ru"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Описание на русском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.description_ru && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="description_kg"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Описание на киргизском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.description_kg && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="description_uz"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Описание на узбекском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.description_uz && true}
                  {...field}
                />
              )}
            />

            <Controller
              name="description_en"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Описание на английском"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.description_en && true}
                  {...field}
                />
              )}
            />
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={singIn}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
